import { useState, useEffect } from "react";
import { getCategories } from "@/services/apis/modules/category";
import { ICategoryResponse } from "@/interfaces/category";

export const useGetCategories = () => {
  const [categoryList, setCategoryList] = useState<ICategoryResponse>();
  const [isLoading, setIsLoading] = useState(true);

  const fetchCategories = async () => {
    setIsLoading(true);
    const categories = await getCategories({ pageIndex: 1, pageSize: 20 });
    setCategoryList(categories);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categoryList,
    isLoading,
    fetchCategories,
  };
};
